import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Vat } from '../../entities/control-tables/vat';
import { UserInfo } from 'src/app/tools/models/entities/user-info';


export class VatRequest extends BaseRequest {

    vat : Vat

  constructor(userInfo : UserInfo){
    super(userInfo);
	this.vat = new Vat()
  }
}